/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetPatientPrescriptionFiltersResponseDto,
  GetPaymentLinkResponseDto,
  GetPrescriptionsResponseDto,
  PrescriptionDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPatientPrescriptionFiltersResponseDtoFromJSON,
    GetPatientPrescriptionFiltersResponseDtoToJSON,
    GetPaymentLinkResponseDtoFromJSON,
    GetPaymentLinkResponseDtoToJSON,
    GetPrescriptionsResponseDtoFromJSON,
    GetPrescriptionsResponseDtoToJSON,
    PrescriptionDtoFromJSON,
    PrescriptionDtoToJSON,
} from '../models/index';

export interface AdminGetPrescriptionByIdRequest {
    prescriptionId: string;
}

export interface GetPrescriptionsForAdminRequest {
    statuses?: string;
    page?: number;
    pageSize?: number;
    sortBy?: GetPrescriptionsForAdminSortByEnum;
    orderBy?: string;
    fromDate?: Date;
    toDate?: Date;
    fromPrice?: string;
    toPrice?: string;
    patientId?: string;
    search?: string;
    providerIds?: string;
    includeFormulas?: boolean;
    practiceIds?: string;
    practiceName?: string;
}

export interface GetPrescriptionsForPatientRequest {
    statuses?: string;
    page?: number;
    pageSize?: number;
    sortBy?: GetPrescriptionsForPatientSortByEnum;
    orderBy?: string;
    fromDate?: Date;
    toDate?: Date;
    fromPrice?: number;
    toPrice?: number;
    practiceIds?: string;
    search?: string;
}

export interface PatientCancelPrescriptionRequest {
    prescriptionId: string;
}

export interface PatientGetMedicationPrescriptionHistoryRequest {
    drugName?: string;
}

export interface PatientGetPaymentLinkRequest {
    prescriptionId: string;
}

export interface PatientGetPrescriptionByIdRequest {
    prescriptionId: string;
}

/**
 * 
 */
export class PrescriptionApi extends runtime.BaseAPI {

    /**
     * Admin can access any prescription by ID without permission checks
     * Get prescription by ID for admin
     */
    async adminGetPrescriptionByIdRaw(requestParameters: AdminGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling adminGetPrescriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/prescription/{prescriptionId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionDtoFromJSON(jsonValue));
    }

    /**
     * Admin can access any prescription by ID without permission checks
     * Get prescription by ID for admin
     */
    async adminGetPrescriptionById(requestParameters: AdminGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionDto> {
        const response = await this.adminGetPrescriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin-scoped list of prescriptions across all practices with search, sort, filter, and pagination. Includes practice information.
     * Get prescriptions for admin
     */
    async getPrescriptionsForAdminRaw(requestParameters: GetPrescriptionsForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = (requestParameters['fromDate'] as any).toISOString();
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['toDate'] = (requestParameters['toDate'] as any).toISOString();
        }

        if (requestParameters['fromPrice'] != null) {
            queryParameters['fromPrice'] = requestParameters['fromPrice'];
        }

        if (requestParameters['toPrice'] != null) {
            queryParameters['toPrice'] = requestParameters['toPrice'];
        }

        if (requestParameters['patientId'] != null) {
            queryParameters['patientId'] = requestParameters['patientId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['providerIds'] != null) {
            queryParameters['providerIds'] = requestParameters['providerIds'];
        }

        if (requestParameters['includeFormulas'] != null) {
            queryParameters['includeFormulas'] = requestParameters['includeFormulas'];
        }

        if (requestParameters['practiceIds'] != null) {
            queryParameters['practiceIds'] = requestParameters['practiceIds'];
        }

        if (requestParameters['practiceName'] != null) {
            queryParameters['practiceName'] = requestParameters['practiceName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/prescription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Admin-scoped list of prescriptions across all practices with search, sort, filter, and pagination. Includes practice information.
     * Get prescriptions for admin
     */
    async getPrescriptionsForAdmin(requestParameters: GetPrescriptionsForAdminRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionsResponseDto> {
        const response = await this.getPrescriptionsForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescriptions for a patient
     * Get prescriptions for patient
     */
    async getPrescriptionsForPatientRaw(requestParameters: GetPrescriptionsForPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPrescriptionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['fromDate'] != null) {
            queryParameters['fromDate'] = requestParameters['fromDate'];
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['toDate'] = requestParameters['toDate'];
        }

        if (requestParameters['fromPrice'] != null) {
            queryParameters['fromPrice'] = requestParameters['fromPrice'];
        }

        if (requestParameters['toPrice'] != null) {
            queryParameters['toPrice'] = requestParameters['toPrice'];
        }

        if (requestParameters['practiceIds'] != null) {
            queryParameters['practiceIds'] = requestParameters['practiceIds'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPrescriptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescriptions for a patient
     * Get prescriptions for patient
     */
    async getPrescriptionsForPatient(requestParameters: GetPrescriptionsForPatientRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPrescriptionsResponseDto> {
        const response = await this.getPrescriptionsForPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process Stripe webhook events for prescription checkout.session.completed events
     * Handle Stripe Webhook Events for Prescription Payments
     */
    async handlePrescriptionWebhookRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/providers/prescription/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process Stripe webhook events for prescription checkout.session.completed events
     * Handle Stripe Webhook Events for Prescription Payments
     */
    async handlePrescriptionWebhook(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.handlePrescriptionWebhookRaw(initOverrides);
    }

    /**
     * Cancels a prescription for a patient
     * Cancel prescription for patient
     */
    async patientCancelPrescriptionRaw(requestParameters: PatientCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling patientCancelPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/{prescriptionId}/cancel`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancels a prescription for a patient
     * Cancel prescription for patient
     */
    async patientCancelPrescription(requestParameters: PatientCancelPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.patientCancelPrescriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches prescription history from RXNT EHR system for the authenticated patient
     * Get patient medication prescription history from RXNT
     */
    async patientGetMedicationPrescriptionHistoryRaw(requestParameters: PatientGetMedicationPrescriptionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['drugName'] != null) {
            queryParameters['drugName'] = requestParameters['drugName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches prescription history from RXNT EHR system for the authenticated patient
     * Get patient medication prescription history from RXNT
     */
    async patientGetMedicationPrescriptionHistory(requestParameters: PatientGetMedicationPrescriptionHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.patientGetMedicationPrescriptionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves payment link or invoice for a prescription. Returns checkout URL when PENDING, or invoice URL when PAID. Handles edge cases during webhook processing.
     * Get payment link or invoice for prescription
     */
    async patientGetPaymentLinkRaw(requestParameters: PatientGetPaymentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentLinkResponseDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling patientGetPaymentLink().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/{prescriptionId}/payment-link`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentLinkResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves payment link or invoice for a prescription. Returns checkout URL when PENDING, or invoice URL when PAID. Handles edge cases during webhook processing.
     * Get payment link or invoice for prescription
     */
    async patientGetPaymentLink(requestParameters: PatientGetPaymentLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentLinkResponseDto> {
        const response = await this.patientGetPaymentLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescription by ID for patient
     */
    async patientGetPrescriptionByIdRaw(requestParameters: PatientGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling patientGetPrescriptionById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/{prescriptionId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription by ID for patient
     */
    async patientGetPrescriptionById(requestParameters: PatientGetPrescriptionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionDto> {
        const response = await this.patientGetPrescriptionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get prescription filters for patient
     */
    async patientGetPrescriptionFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPatientPrescriptionFiltersResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/prescription/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPatientPrescriptionFiltersResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get prescription filters for patient
     */
    async patientGetPrescriptionFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPatientPrescriptionFiltersResponseDto> {
        const response = await this.patientGetPrescriptionFiltersRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetPrescriptionsForAdminSortByEnum = {
    Id: 'id',
    Patient: 'patient',
    DateTime: 'dateTime',
    Status: 'status',
    Price: 'price'
} as const;
export type GetPrescriptionsForAdminSortByEnum = typeof GetPrescriptionsForAdminSortByEnum[keyof typeof GetPrescriptionsForAdminSortByEnum];
/**
 * @export
 */
export const GetPrescriptionsForPatientSortByEnum = {
    Id: 'id',
    Patient: 'patient',
    DateTime: 'dateTime',
    Status: 'status',
    Price: 'price'
} as const;
export type GetPrescriptionsForPatientSortByEnum = typeof GetPrescriptionsForPatientSortByEnum[keyof typeof GetPrescriptionsForPatientSortByEnum];
